import { loadable } from 'react-lazily/loadable';
const { REACT_APP_PROJECT_CODE: projectCode } = process.env;
const DashboardContainer = loadable(() => import(`../venture/${projectCode?.substring(0, 4)}/containers/DashboardContainer`).catch((e) => {
    debug && console.log(`Dashboard err in getAppContainer ${e.message}`);
    return import(`./DashboardContainer`);
})).default;
const debug = process.env.REACT_APP_DEBUG && false;
export default DashboardContainer;
